import { useTranslation } from "react-i18next";
import Button from "../../../components/Button";

const ConfirmModal = ({
  title,
  children,
  onCancel,
  onConfirm,
  confirmLabel = "Confirm",
  loading = false,
}) => {
  const { t } = useTranslation();
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 overflow-hidden">
        <div className="bg-primary-500 px-6 py-4">
          <h2 className="text-white text-lg font-semibold text-center">{title}</h2>
        </div>
        <div className="px-6 py-5 text-sm text-gray-700 space-y-2">{children}</div>
        <div className="px-6 pb-5 flex gap-3">
          <Button variant="secondary" onClick={onCancel} className="flex-1">
            {t('common.cancel')}
          </Button>
          <Button loading={loading} onClick={onConfirm} className="flex-1">
            {confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
